import abrinq from 'imagens/logo-abrink.jpg'
import {Card1, Card2} from  'components/Card'
import { Grid } from '@material-ui/core'
import { useDevice } from 'components/DeviceContext.js'
const Parceiros = () => {
    const {isMobile} = useDevice();
    return (
        <>
            <Grid container style={{
                justifyContent: 'center',
                display: 'flex',
                maxHeight: '100%',
                marginBottom: '5em',
                marginTop: '1em',
                flexDirection: isMobile ? 'column' : '',

            }}>
                <Grid item xs={12} md={5} style={{ marginBottom: '1em'}}>
                    <h1 style={{ color: 'var(--azul)', textAlign: 'center', fontWeight: '600', fontSize: '2em' }}>Parceiros</h1>
                    <Grid style={{
                        margin: '2em'
                    }}>
                        <img src={abrinq} alt="Logo abrinq" />
                    </Grid>
                </Grid>

                <Grid item xs={12} md={4} style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    <Card1 />
                    <Card2 />

                </Grid>
            </Grid>
        </>
    )
}
export default Parceiros;
